import { EntityTypes } from './enums/entityTypes';

export interface RequestQuestion {
  questionId: string;
  requestId: string;
  orgId: string;
  question: string;
  entityType: EntityTypes.requestQuestion;
  answer?: string;
  answered: boolean;
  created: number;
  lastUpdated: number;
  answeredDate?: number;
}
